import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { isUserAuthenticated } from '../state/user/user.store';

export const authGuard = (
  _: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  if (!isUserAuthenticated()) {
    return router.createUrlTree(['login'], {
      queryParams: { urlState: encodeURIComponent(state.url) },
    });
  } else {
    return true;
  }
};
